export function app() {
    console.log("Tema Municipal - SubCultura")
}